export const stringConstant = {
    HEADING_TITLE: 'Clinics on clouds',
    SIGNIN: 'Sign In',
    DOWNLOAD_TITLE: 'Download Kiosk App',
    DOWNLOAD_BODY: 'The COC Health KIOSK app represents a digital platform meticulously crafted to furnish users with a broad spectrum of healthcare services and information. Its functionalities encompass the screening of over 60 health parameters, monitoring of vital signs and health metrics, provision of medical resources and information, as well as facilitating telemedicine consultations. This application is purposefully designed to afford users convenient and efficient access to an array of healthcare services and support.',
    GET_STARTED: 'Get Started',
    LOGIN_TITLE: 'Empowering Society For A Healthier Tomorrow',
    LOGIN_BODY: 'Making preventive healthcare more Affordable, Advanced and Accessible',
    CLINIC_ID: 'Clinic ID',
    PASSWORD: 'Password',
    DOWNLOAD: 'Download',
    LOGOUT: 'Logout'
}